import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { setSettings } from "../actions/DashboardDesigner/setting";
import { setUserApps } from "../actions/DashboardDesigner/userAppsAction";
import { getLicenses, getCustomApps, getUserInfo } from "../apiFactory/QueryBuilder";
import WithLoader from "../components/HOC/WithLoader";
import { apps } from "../utility/appsConfig";
import { withRouter } from '../hoc/withRouter';
import { populateAmplitudeParams } from "../services/DashboardDesigner/amplitudeService";
import { makeAppcuesUserProperties } from "../services/helper";
import { getRoles } from "../apiFactory/DashboardDesigner/P3fy";
import { setUserInfo } from "../actions/DashboardDesigner/userInfoAction";
import personProfileIcon from "../assets/person-profile.jpg";
import { logger } from "../utility/logger";

class AppWrapper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true
		};
		this.accessToken = localStorage.getItem("$LoopBack$accessTokenId");
		this.userId = localStorage.getItem("$LoopBack$currentUserId");
	}

	getUserApps = () => {
		getLicenses(this.accessToken)
			.then(res => {
				const licenses = res.licenses || [];
				var licenseType = licenses
					.map(ele => ele.licenseType)
					.filter((ele, i, licenses) => licenses.indexOf(ele) == i);
				// An app is available when the user holds ANY of the licences that unlock it.
				// Every pre-existing entry lists exactly one licence, so this is a no-op for
				// them; it lets a single entry cover alternatives (e.g. ESG or GHG).
				var filteredApps = apps.filter(ele => {
					const required = ele.licenses || [];
					return !required.length || required.some(val => licenseType.includes(val));
				});
				getCustomApps(this.accessToken).then(res => {
					const customApps = res.customApps || [];
					var allApps = [...customApps, ...filteredApps];
					var userApps = {};
					allApps.forEach(app => {
						if (!userApps[app.product]) {
							userApps[app.product] = [];
						}
						const found = userApps[app.product].some(el => el.id === app.id);
						if (!found) userApps[app.product].push(app);
					});
					this.props.setUserApps(userApps);
				});
			})
			.catch(err => {
				console.log(err);
			});
	};

	preparePropertiesObject = () => {
		const { organization, dashboardId, widgetId, dashboardContainer, dashboards, widgets } = this.props;

		const currentWidget = widgets.find(widget => widget.id === widgetId);
		const currentDashboard = dashboards.find(dashboard => dashboard.id === dashboardId);
		const dashboardContainerId = currentDashboard && currentDashboard.dashboardContainerId;
		const currentDashboardContainer =
			dashboardContainerId &&
			dashboardContainer.find(container => container.id === dashboardContainerId);
		return {
			orgId: organization.id,
			dashboardContainerId,
			dashboardContainerName: currentDashboardContainer ? currentDashboardContainer.name : "",
			dashboardId,
			dashboardName: currentDashboard ? currentDashboard.name : "",
			widgetId,
			refWidgetId: currentWidget ? currentWidget.refWidgetId : "",
			widgetName: currentWidget
				? currentWidget.configuration && currentWidget.configuration.config.name
				: ""
		};
	};

	prepareAmplitudeEventParams = () => {
		const amplitudeEventParams = { ...this.preparePropertiesObject() };
		populateAmplitudeParams(amplitudeEventParams);
	};

	setUserInformation = () => {
		getRoles().then(roles => this.props.setUserInfo({ adminRoles: roles }));
		getUserInfo(this.accessToken, this.userId)
			.then(res => {
				const profileData = res.personProfile;
				const email = res.email ? res.email : "Anonymous User";
				if (profileData) {
					this.props.setUserInfo({
						image: profileData.photoUrl ? profileData.photoUrl : personProfileIcon,
						name: profileData.name ? profileData.name : email,
						email: email
					});
				} else {
					this.props.setUserInfo({
						image: personProfileIcon,
						name: email,
						email: email
					});
				}
			})
			.catch(err => {
				this.props.setUserInfo({
					image: personProfileIcon,
					name: "Anonymous user",
					email: ""
				});
			});
	};

	prepareAppcuesObject = () => {
		const {
			userInfo: { dashboardRole = "" }
		} = this.props;
		const pathname = window.location.pathname;
		var screen = pathname.includes("preview") ? "preview" : pathname.includes("editor") ? "editor" : null;
		var appcuesPropertiesObject = {
			...makeAppcuesUserProperties(this.props),
			...this.preparePropertiesObject()
		};
		appcuesPropertiesObject.organizationId = appcuesPropertiesObject.orgId;
		delete appcuesPropertiesObject.orgId;
		return {
			...appcuesPropertiesObject,
			userRole: dashboardRole,
			ui_screen: screen
		};
	};

	trackAppcues = () => {
		if (typeof window.Appcues === 'undefined') return;
		try {
			var appcuesIdentifyObject = { ...this.prepareAppcuesObject() };
			var userId = localStorage.getItem("$LoopBack$currentUserId");
			window.Appcues.identify(userId, appcuesIdentifyObject);
			window.Appcues.page();
		} catch (err) {
			console.warn('Appcues tracking failed:', err);
		}
	};

	componentDidUpdate({
		organization: prevOrg,
		dashboardId: prevDashboardId,
		widgetId: prevWidgetId,
		location: prevLocation
	}) {
		const {
			organization,
			dashboardId,
			widgetId,
			location: { pathname }
		} = this.props;
		const hasChanged = prevOrg.id !== organization.id || prevDashboardId !== dashboardId || prevWidgetId !== widgetId;
		if (hasChanged) {
			this.prepareAmplitudeEventParams();
			this.trackAppcues();
		}
	}

	componentDidMount() {
		if (typeof FreshworksWidget === 'function') {
			FreshworksWidget("hide", "launcher");
		}
		logger("AppWrapper mounted", "success");
		this.getUserApps();
		this.prepareAmplitudeEventParams();
		this.setUserInformation();
		this.trackAppcues();
		this.setState({ loading: false });
	}

	render() {
		const { children } = this.props;
		return <WithLoader loading={this.state.loading}>{children}</WithLoader>;
	}
}

const mapStateToProps = ({
	organization,
	userAppsInfo,
	currentDashboardId,
	currentWidgetId,
	dashboardContainer,
	dashboards,
	userInfo,
	widgets
}) => ({
	organization,
	userApps: userAppsInfo,
	dashboardId: currentDashboardId,
	widgetId: currentWidgetId,
	dashboardContainer,
	dashboards,
	widgets,
	userInfo
});

const mapDispatchToProps = dispatch => {
	return {
		setUserApps: obj => {
			dispatch(setUserApps(obj));
		},
		setUserInfo: obj => {
			dispatch(setUserInfo(obj));
		}
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppWrapper));
